// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientResponseModel {
    /**
    * @description Gets or sets the middle name.
    */
    'middleName'?: string | null;
    /**
    * @description Gets or sets the suffix.
    */
    'suffix'?: string | null;
    /**
    * @description Gets or sets the zip code.
    */
    'zipCode'?: string | null;
    /**
    * @description Gets or sets the date of birth.
    */
    'dateOfBirth'?: string | null;
    /**
    * @description Gets or sets the first name.
    */
    'firstName'?: string | null;
    /**
    * @description Gets or sets the last name.
    */
    'lastName'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientResponseModel>> = [
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
        {
            "name":     "zipCode",
            "baseName": "zipCode",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientResponseModel.attributeTypeMap;
    }
}
